import React from 'react';
import { Link } from 'react-router-dom';

function Credentials() {
    const ChangePageTitle = (pageTitle) => {
        document.title = pageTitle;
    };
    ChangePageTitle('Portfolio - Credentials');
    return (
        <section className="credential-area">
            <div className="container">
                <div className="gx-row d-flex">
                    <div className="credential-sidebar-wrap" data-aos="zoom-in">
                        <div className="credential-sidebar text-center">
                            <div className="shadow-box">
                                <div className="img-box">
                                    <img
                                        src="/assets/images/me2.webp"
                                        alt="About Me"
                                    />
                                </div>
                                <h2>Pankaj Kumar</h2>
                                <p>@CodeWithPankaj</p>

                                <ul className="social-links d-flex justify-content-center">
                                    <li>
                                        <Link
                                            to="https://www.linkedin.com/in/pankaj-kumar-90"
                                            target="_blank"
                                        >
                                            <i className="iconoir-linkedin"></i>
                                        </Link>
                                    </li>{' '}
                                    <li>
                                        <Link
                                            to="https://github.com/pankajbaliyan"
                                            target="_blank"
                                        >
                                            <i className="iconoir-github"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="https://www.youtube.com/c/CodeWithPankaj1?sub_confirmation=1"
                                            target="_blank"
                                        >
                                            <i className="iconoir-youtube"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="mailto:pankajbaliyan90@gmail.com">
                                            <i className="iconoir-mail"></i>
                                        </Link>
                                    </li>
                                </ul>

                                <Link
                                    to="https://drive.google.com/file/d/1obJzdRwMp9SDr-elyP03yC7rDhV98QTX/view"
                                    target="_blank"
                                    className="theme-btn d-flex justify-content-evenly align-items-center"
                                >
                                    Resume
                                    <i className="iconoir-download"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div
                        data-elementor-type="wp-page"
                        data-elementor-id="1065"
                        className="elementor elementor-1065"
                    >
                        <section
                            className="elementor-section elementor-top-section elementor-element elementor-element-6d57135 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                            data-id="6d57135"
                            data-element_type="section"
                        >
                            <div className="elementor-container elementor-column-gap-no">
                                <div
                                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2705f96 margin-0"
                                    data-id="2705f96"
                                    data-element_type="column"
                                >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                        <div
                                            className="elementor-element elementor-element-35461e7 elementor-widget elementor-widget-gridxdacredentialcontentbox"
                                            data-id="35461e7"
                                            data-element_type="widget"
                                            data-widget_type="gridxdacredentialcontentbox.default"
                                        >
                                            <div className="elementor-widget-container">
                                                <div className="credential-content flex-1">
                                                    <div
                                                        className="credential-about"
                                                        data-aos="zoom-in"
                                                    >
                                                        <h2>About Me</h2>
                                                        Embarking on a web
                                                        development voyage three
                                                        years ago, I have been a
                                                        relentless explorer of
                                                        this digital realm. My
                                                        path has been paved with
                                                        diverse experiences,
                                                        collaborating with
                                                        various enterprises to
                                                        bring their visions to
                                                        life. Currently, I'm a
                                                        proud member of the
                                                        uCertify family, where I
                                                        contribute my skills as
                                                        a web application
                                                        developer. The realm of
                                                        NodeJS, ReactJS, and
                                                        Svelte is my playground,
                                                        crafting interactive and
                                                        adaptive web
                                                        applications that
                                                        seamlessly dance between
                                                        desktop and mobile
                                                        screens.
                                                        <br />
                                                        <br />
                                                        <p>
                                                            Passionate about the
                                                            art of coding and
                                                            the magic of pixels,
                                                            I am a dedicated web
                                                            developer who weaves
                                                            together lines of
                                                            code to craft
                                                            mesmerizing web
                                                            pages. My journey is
                                                            a symphony of
                                                            creativity and
                                                            technology,
                                                            orchestrating
                                                            stunning designs
                                                            that resonate with
                                                            users. With an
                                                            intuitive
                                                            understanding of web
                                                            technologies, I
                                                            sculpt functional
                                                            and responsive web
                                                            layouts that cater
                                                            to the unique needs
                                                            of each individual.
                                                        </p>{' '}
                                                    </div>

                                                    <div className="credential-edc-exp credential-experience">
                                                        <h2 data-aos="fade-up">
                                                            EXPERIENCE
                                                        </h2>
                                                        <div
                                                            className="credential-edc-exp-item"
                                                            data-aos="zoom-in"
                                                        >
                                                            <h4>
                                                                Jan 2022 – Nov
                                                                2022
                                                            </h4>
                                                            <h3>
                                                                Web Application
                                                                Developer
                                                            </h3>
                                                            <h5>uCertify</h5>•
                                                            Continuous
                                                            enhancement and
                                                            maintenance: Enhance
                                                            and maintain live
                                                            software in
                                                            real-time. <br />•
                                                            Collaborative
                                                            cross-functional
                                                            development:
                                                            Collaborate with
                                                            teams to implement
                                                            new features,
                                                            troubleshoot bugs,
                                                            and optimize code.{' '}
                                                            <br />• Performance
                                                            optimization:
                                                            Improve software
                                                            functionality, fix
                                                            bugs efficiently,
                                                            and optimize code
                                                            for better
                                                            performance.{' '}
                                                        </div>
                                                        <div
                                                            className="credential-edc-exp-item"
                                                            data-aos="zoom-in"
                                                        >
                                                            <h4>
                                                                Jun 2021 – Nov
                                                                2021
                                                            </h4>
                                                            <h3>
                                                                Intern - Web
                                                                Developer
                                                            </h3>
                                                            <h5>
                                                                Blue Planet
                                                                Solutions
                                                            </h5>
                                                            • Team leadership:
                                                            Manage a 10-member
                                                            junior team for web
                                                            app development.{' '}
                                                            <br />• High-quality
                                                            web apps: Create
                                                            customer-focused web
                                                            applications. <br />
                                                            • Code optimization
                                                            and feature
                                                            enhancement:
                                                            Optimize code and
                                                            add new features for
                                                            improved
                                                            performance.{' '}
                                                        </div>
                                                    </div>

                                                    <div className="credential-edc-exp credential-education">
                                                        <h2 data-aos="fade-up">
                                                            Education
                                                        </h2>
                                                        <div
                                                            className="credential-edc-exp-item"
                                                            data-aos="zoom-in"
                                                        >
                                                            <h4>
                                                                July 2022 – Aug
                                                                2024 (Pursuing)
                                                            </h4>
                                                            <h3>
                                                                Master Of
                                                                Computer
                                                                Application
                                                            </h3>
                                                            <h5>
                                                                Dr. A. P. J.
                                                                Abdul Kalam
                                                                Technical
                                                                University,
                                                                Lucknow
                                                            </h5>
                                                            Currently pursuing a
                                                            Master of Computer
                                                            Application (MCA)
                                                            degree, I am proud
                                                            to have achieved a
                                                            commendable score of
                                                            74% thus far in my
                                                            academic journey.
                                                            This advanced
                                                            program has provided
                                                            me with a deeper
                                                            understanding of
                                                            computer science and
                                                            its myriad
                                                            applications. From
                                                            complex algorithms
                                                            to advanced software
                                                            development, the MCA
                                                            curriculum has
                                                            equipped me with the
                                                            tools and knowledge
                                                            to tackle intricate
                                                            challenges in the
                                                            digital realm.{' '}
                                                        </div>
                                                        <div
                                                            className="credential-edc-exp-item"
                                                            data-aos="zoom-in"
                                                        >
                                                            <h4>
                                                                July 2019 – Aug
                                                                2022
                                                            </h4>
                                                            <h3>
                                                                Bachelor Of
                                                                Computer
                                                                Application
                                                            </h3>
                                                            <h5>
                                                                Chaudhary Charan
                                                                Singh
                                                                University,
                                                                Meerut
                                                            </h5>
                                                            Having pursued a
                                                            Bachelor of Computer
                                                            Application (BCA)
                                                            degree, I am
                                                            thrilled to have
                                                            achieved a
                                                            commendable 70% in
                                                            my academic journey.
                                                            The realm of
                                                            computer
                                                            applications has not
                                                            only been my field
                                                            of study but a realm
                                                            of discovery and
                                                            innovation.
                                                            Throughout my BCA
                                                            program, I delved
                                                            into the intricate
                                                            world of
                                                            programming,
                                                            software
                                                            development, and
                                                            information
                                                            technology, honing
                                                            my skills in
                                                            problem-solving and
                                                            analytical thinking.{' '}
                                                        </div>
                                                    </div>

                                                    <div className="skills-wrap pb-5">
                                                        <h2 data-aos="fade-up">
                                                            Technical Skills
                                                        </h2>
                                                        <div className="d-grid skill-items gap-24 flex-wrap">
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    81%
                                                                </span>
                                                                <h3 className="name">
                                                                    React
                                                                </h3>
                                                                <p>
                                                                    Front-End
                                                                    Power
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    85%
                                                                </span>
                                                                <h3 className="name">
                                                                    JavaScript
                                                                </h3>
                                                                <p>
                                                                    Interactive
                                                                    Web
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    89%
                                                                </span>
                                                                <h3 className="name">
                                                                    MongoDB
                                                                </h3>
                                                                <p>
                                                                    Database
                                                                    Management
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    94%
                                                                </span>
                                                                <h3 className="name">
                                                                    Node.js
                                                                </h3>
                                                                <p>
                                                                    Backend
                                                                    Wizard
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    82%
                                                                </span>
                                                                <h3 className="name">
                                                                    Redux
                                                                </h3>
                                                                <p>
                                                                    State
                                                                    Management
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    88%
                                                                </span>
                                                                <h3 className="name">
                                                                    Express.js
                                                                </h3>
                                                                <p>
                                                                    Server
                                                                    Creation
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    93%
                                                                </span>
                                                                <h3 className="name">
                                                                    GitHub
                                                                </h3>
                                                                <p>
                                                                    Version
                                                                    Control
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <span className="percent">
                                                                    96%
                                                                </span>
                                                                <h3 className="name">
                                                                    DSA
                                                                </h3>
                                                                <p>
                                                                    Problem
                                                                    Solver
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="skills-wrap mt-5 pb-5">
                                                        <h2 data-aos="fade-up">
                                                            Soft Skills
                                                        </h2>
                                                        <div className="d-grid skill-items gap-24 flex-wrap">
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    Communication
                                                                </h3>
                                                                <p>
                                                                    Effective
                                                                    Interaction
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    IT Sector
                                                                    Knowledge
                                                                </h3>
                                                                <p>
                                                                    Industry
                                                                    Insights
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    Teamwork
                                                                </h3>
                                                                <p>
                                                                    Collaborative
                                                                    Spirit
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    Critical
                                                                    Thinking
                                                                </h3>
                                                                <p>
                                                                    Analytical
                                                                    Mindset
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="skills-wrap mt-5">
                                                        <h2 data-aos="fade-up">
                                                            Awards
                                                        </h2>
                                                        <div className="d-grid skill-items gap-24 flex-wrap">
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    400+ DSA
                                                                    Questions
                                                                </h3>
                                                                <p>
                                                                    Platform
                                                                    Mastery
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    CoCubes
                                                                    Score 72%
                                                                </h3>
                                                                <p>
                                                                    Aptitude
                                                                    Proficiency
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    GDG Gurugram
                                                                    Member
                                                                </h3>
                                                                <p>
                                                                    Tech
                                                                    Community
                                                                    Enthusiast
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="skill-item"
                                                                data-aos="zoom-in"
                                                            >
                                                                <h3 className="name">
                                                                    2022 Batch
                                                                    (College)
                                                                    1st
                                                                    Placement
                                                                </h3>
                                                                <p>
                                                                    Emerging
                                                                    Talent
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Credentials;
